import { ReactNode } from "react";

import { IconComponent } from "types/Icon";

import Feedback, { FeedbackProps } from "../Feedback";
import { FeedbackVariant } from "../Feedback/types";

// ts-prune-ignore-next
export type CalloutProps = {
  announce?: FeedbackProps["announce"];
  children?: ReactNode;
  className?: string;
  closeCallback?: FeedbackProps["closeCallback"];
  closeLabel?: FeedbackProps["closeLabel"];
  icon?: IconComponent;
  permanentCloseConfirmationTooltipInfo?: ReactNode;
  storageKey?: string;
  title?: ReactNode;
  variant: FeedbackVariant;
  withPermanentCloseConfirmation?: boolean;
};

const Callout = ({
  announce,
  children,
  className,
  closeCallback,
  closeLabel,
  icon,
  permanentCloseConfirmationTooltipInfo,
  storageKey,
  title,
  variant,
  withPermanentCloseConfirmation,
}: CalloutProps) => {
  return (
    <Feedback
      variant={variant}
      type="callout"
      title={title}
      storageKey={storageKey}
      className={className}
      closeCallback={closeCallback}
      withPermanentCloseConfirmation={withPermanentCloseConfirmation}
      permanentCloseConfirmationTooltipInfo={permanentCloseConfirmationTooltipInfo}
      icon={icon}
      announce={announce}
      closeLabel={closeLabel}
    >
      {children}
    </Feedback>
  );
};

Callout.displayName = "DS.Callout";

export default Callout;
